import ActivityCard from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import ShowCardContent from "./ShowActivityCardContent";

interface Props {
  activity: server.dto.ShowActivity
}

const ShowActivityRowCard = (props: Props) => {
  const { activity } = props;
  const { timestampUtc } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  return <ActivityCard
    activity={activity}
    getTitle={() => activity.action.text}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}
  >
    <ShowCardContent activity={activity} />
  </ActivityCard>;
};

export default ShowActivityRowCard;